<template>
    <div class="row w-100">
        <div class="col-md-12 mb-3 w-100">
            <select ref="input" id="timezone" name="timezone" placeholder="Select timezone Name" v-model="timezoneValue"
                    class="form-control form-control-lg input-new-design-customer-attribute">
            </select>
            <span class="text text-danger error-label">{{ validationErrors.timezone }}</span>
        </div>
    </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import TomSelect from "tom-select";
import { getCustomerTimeZones } from '@/modules/common/api';

export default {
    name: "SelectTimeZone",
    props: ["value", "defaultCompany", "validationErrors"],
    data() {
        return {
            names: [],
            select: null,
            timezonesAll: [],
            timezoneValue: this.value,
        };
    },
    mounted() {
        this.getCustomerTimeZones();

    },
    methods: {
        async getCustomerTimeZones() {
            try {
                const response = await getCustomerTimeZones();
                this.timezonesAll = response.data;
                this.initiateDropdown();
                this.listenToTomSelectEvents();
            } catch (error) {
                console.error(error);
            }
        },
        initiateDropdown() {
            this.select = new TomSelect(this.$refs.input, {
                valueField: "timezoneName",
                labelField: "timezoneName",
                searchField: ["timezoneName"],
                options: this.timezonesAll,
                create: false,
                render: {
                    option: (item, escape) => `<div>${escape(item.timezoneName)} (${escape(item.timezone)})</div>`,
                    item: (item, escape) => `<div>${escape(item.timezoneName)} (${escape(item.timezone)})</div>`,
                },
                onItemAdd: (value) => {
                    this.timezoneValue = value;
                },
                onItemRemove: () => {
                    this.timezoneValue = null;
                },
            });

            if (this.timezoneValue) {
                this.select.addItem(this.timezoneValue, true);
            }
        },
        listenToTomSelectEvents() {
            EventBus.$on('timeZoneChanged', this.handleTimeZoneChanged);
            EventBus.$on('onCountrySelected', this.handleCountrySelected);
            EventBus.$on('onAddressChangedTimeZone', this.handleAddressChangedTimeZone);

        },
        handleCountrySelected(value) {
            this.names = value;
            this.select.clearOptions();
            this.select.addOptions(this.names);

            if (this.timezoneValue) {
                let SelectTimeZoneSelected =  this.timezonesAll.find(timezonea => timezonea.timezoneName == this.timezoneValue);
                this.names[251] = (SelectTimeZoneSelected);
            }
                this.select.addItem(this.names[251]?.timezoneName, false);

        },
        handleAddressChangedTimeZone(value) {
            if (value && value !== this.timezoneValue) {
                this.timezoneValue = value;
                this.select.addItem(this.timezoneValue, true);
            }
        },
        handleTimeZoneChanged(value){
            if (value){
                this.timezoneValue = value;

            }
        }
    },
    watch: {
        timezoneValue(val) {
            if (val && this.select) {
                this.$emit('input',val)
                this.select.clear();
                this.select.addItem(val, true);
            }
        },
    },
}
</script>

<style scoped>
</style>
